import { ParsedPreset, PresetVisibility } from '../definition';

export function filterTemplatesByTab<T = any>(
  items: ParsedPreset<T>[],
  tab: PresetVisibility
): ParsedPreset<T>[] {
  const presets = items ?? [];
  let draft: ParsedPreset<T>[];

  switch (tab) {
    case PresetVisibility.INTERNAL:
      draft = presets.filter((i) => i.visibility === PresetVisibility.INTERNAL);
      break;

    case PresetVisibility.PRIVATE:
      draft = presets.filter((i) => i.visibility === PresetVisibility.PRIVATE);
      break;

    default:
      draft = presets.slice();
      break;
  }

  return draft;
}
